export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ChatBranchAiChatMessagesDynamicZoneInput: any;
  ChatBranchChatMessagesDynamicZoneInput: any;
  ChatBranchOver50ChatMessagesDynamicZoneInput: any;
  ChatEventChatMessagesDynamicZoneInput: any;
  DateTime: any;
  I18NLocaleCode: any;
  JSON: any;
  Long: any;
  PostProcessingBehindDynamicZoneInput: any;
  PostProcessingInfrontDynamicZoneInput: any;
  Upload: any;
};

export type Age = {
  __typename?: 'Age';
  button: ComponentGeneralButton;
  cardTitle: Scalars['String'];
  chatbotCameraDeniedInfo: Scalars['String'];
  chatbotCameraPermissionInstructionsChrome: Array<Maybe<ComponentGeneralBulletPoint>>;
  chatbotCameraPermissionInstructionsMacOS: Array<Maybe<ComponentGeneralBulletPoint>>;
  chatbotCameraPermissionInstructionsiOS: Array<Maybe<ComponentGeneralBulletPoint>>;
  chatbotCameraPermissionsDeniedButton: ComponentGeneralButton;
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<AgeRelationResponseCollection>;
  selectButtonOne: ComponentGeneralButton;
  selectButtonThree: ComponentGeneralButton;
  selectButtonTwo: ComponentGeneralButton;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type AgeChatbotCameraPermissionInstructionsChromeArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AgeChatbotCameraPermissionInstructionsMacOsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AgeChatbotCameraPermissionInstructionsiOsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AgeEntity = {
  __typename?: 'AgeEntity';
  attributes: Maybe<Age>;
  id: Maybe<Scalars['ID']>;
};

export type AgeEntityResponse = {
  __typename?: 'AgeEntityResponse';
  data: Maybe<AgeEntity>;
};

export type AgeInput = {
  button: InputMaybe<ComponentGeneralButtonInput>;
  cardTitle: InputMaybe<Scalars['String']>;
  chatbotCameraDeniedInfo: InputMaybe<Scalars['String']>;
  chatbotCameraPermissionInstructionsChrome: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  chatbotCameraPermissionInstructionsMacOS: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  chatbotCameraPermissionInstructionsiOS: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  chatbotCameraPermissionsDeniedButton: InputMaybe<ComponentGeneralButtonInput>;
  selectButtonOne: InputMaybe<ComponentGeneralButtonInput>;
  selectButtonThree: InputMaybe<ComponentGeneralButtonInput>;
  selectButtonTwo: InputMaybe<ComponentGeneralButtonInput>;
};

export type AgeRelationResponseCollection = {
  __typename?: 'AgeRelationResponseCollection';
  data: Array<AgeEntity>;
};

export type BooleanFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains: InputMaybe<Scalars['Boolean']>;
  containsi: InputMaybe<Scalars['Boolean']>;
  endsWith: InputMaybe<Scalars['Boolean']>;
  eq: InputMaybe<Scalars['Boolean']>;
  eqi: InputMaybe<Scalars['Boolean']>;
  gt: InputMaybe<Scalars['Boolean']>;
  gte: InputMaybe<Scalars['Boolean']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt: InputMaybe<Scalars['Boolean']>;
  lte: InputMaybe<Scalars['Boolean']>;
  ne: InputMaybe<Scalars['Boolean']>;
  not: InputMaybe<BooleanFilterInput>;
  notContains: InputMaybe<Scalars['Boolean']>;
  notContainsi: InputMaybe<Scalars['Boolean']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith: InputMaybe<Scalars['Boolean']>;
};

export type CancelCall = {
  __typename?: 'CancelCall';
  buttonOne: ComponentGeneralButton;
  buttonThree: ComponentGeneralButton;
  buttonTwo: ComponentGeneralButton;
  cardDescription: Scalars['String'];
  cardSubtitle: Scalars['String'];
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<CancelCallRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type CancelCallEntity = {
  __typename?: 'CancelCallEntity';
  attributes: Maybe<CancelCall>;
  id: Maybe<Scalars['ID']>;
};

export type CancelCallEntityResponse = {
  __typename?: 'CancelCallEntityResponse';
  data: Maybe<CancelCallEntity>;
};

export type CancelCallInput = {
  buttonOne: InputMaybe<ComponentGeneralButtonInput>;
  buttonThree: InputMaybe<ComponentGeneralButtonInput>;
  buttonTwo: InputMaybe<ComponentGeneralButtonInput>;
  cardDescription: InputMaybe<Scalars['String']>;
  cardSubtitle: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
};

export type CancelCallRelationResponseCollection = {
  __typename?: 'CancelCallRelationResponseCollection';
  data: Array<CancelCallEntity>;
};

export type ChatBranch = {
  __typename?: 'ChatBranch';
  chatMessages: Array<Maybe<ChatBranchChatMessagesDynamicZone>>;
  createdAt: Maybe<Scalars['DateTime']>;
  group: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ChatBranchAi = {
  __typename?: 'ChatBranchAi';
  chatMessages: Array<Maybe<ChatBranchAiChatMessagesDynamicZone>>;
  createdAt: Maybe<Scalars['DateTime']>;
  group: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ChatBranchAiChatMessagesDynamicZone = ComponentChatMessageButtonGroup | ComponentChatMessageGoToBranch | ComponentChatMessageImage | ComponentChatMessageLink | ComponentChatMessageText | Error;

export type ChatBranchAiEntity = {
  __typename?: 'ChatBranchAiEntity';
  attributes: Maybe<ChatBranchAi>;
  id: Maybe<Scalars['ID']>;
};

export type ChatBranchAiEntityResponse = {
  __typename?: 'ChatBranchAiEntityResponse';
  data: Maybe<ChatBranchAiEntity>;
};

export type ChatBranchAiEntityResponseCollection = {
  __typename?: 'ChatBranchAiEntityResponseCollection';
  data: Array<ChatBranchAiEntity>;
  meta: ResponseCollectionMeta;
};

export type ChatBranchAiFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ChatBranchAiFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  group: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<ChatBranchAiFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ChatBranchAiFiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type ChatBranchAiInput = {
  chatMessages: InputMaybe<Array<Scalars['ChatBranchAiChatMessagesDynamicZoneInput']>>;
  group: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

export type ChatBranchChatMessagesDynamicZone = ComponentChatMessageButtonGroup | ComponentChatMessageGoToBranch | ComponentChatMessageImage | ComponentChatMessageLink | ComponentChatMessageText | Error;

export type ChatBranchEntity = {
  __typename?: 'ChatBranchEntity';
  attributes: Maybe<ChatBranch>;
  id: Maybe<Scalars['ID']>;
};

export type ChatBranchEntityResponse = {
  __typename?: 'ChatBranchEntityResponse';
  data: Maybe<ChatBranchEntity>;
};

export type ChatBranchEntityResponseCollection = {
  __typename?: 'ChatBranchEntityResponseCollection';
  data: Array<ChatBranchEntity>;
  meta: ResponseCollectionMeta;
};

export type ChatBranchFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ChatBranchFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  group: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<ChatBranchFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ChatBranchFiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type ChatBranchInput = {
  chatMessages: InputMaybe<Array<Scalars['ChatBranchChatMessagesDynamicZoneInput']>>;
  group: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

export type ChatBranchOver50 = {
  __typename?: 'ChatBranchOver50';
  chatMessages: Maybe<Array<Maybe<ChatBranchOver50ChatMessagesDynamicZone>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  group: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ChatBranchOver50ChatMessagesDynamicZone = ComponentChatMessageButtonGroup | ComponentChatMessageGoToBranch | ComponentChatMessageImage | ComponentChatMessageLink | ComponentChatMessageText | Error;

export type ChatBranchOver50Entity = {
  __typename?: 'ChatBranchOver50Entity';
  attributes: Maybe<ChatBranchOver50>;
  id: Maybe<Scalars['ID']>;
};

export type ChatBranchOver50EntityResponse = {
  __typename?: 'ChatBranchOver50EntityResponse';
  data: Maybe<ChatBranchOver50Entity>;
};

export type ChatBranchOver50EntityResponseCollection = {
  __typename?: 'ChatBranchOver50EntityResponseCollection';
  data: Array<ChatBranchOver50Entity>;
  meta: ResponseCollectionMeta;
};

export type ChatBranchOver50FiltersInput = {
  and: InputMaybe<Array<InputMaybe<ChatBranchOver50FiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  group: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<ChatBranchOver50FiltersInput>;
  or: InputMaybe<Array<InputMaybe<ChatBranchOver50FiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type ChatBranchOver50Input = {
  chatMessages: InputMaybe<Array<Scalars['ChatBranchOver50ChatMessagesDynamicZoneInput']>>;
  group: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

export type ChatEvent = {
  __typename?: 'ChatEvent';
  chatMessages: Array<Maybe<ChatEventChatMessagesDynamicZone>>;
  createdAt: Maybe<Scalars['DateTime']>;
  group: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ChatEventChatMessagesDynamicZone = ComponentChatMessageButtonGroup | ComponentChatMessageGoToBranch | ComponentChatMessageImage | ComponentChatMessageLink | ComponentChatMessageText | Error;

export type ChatEventEntity = {
  __typename?: 'ChatEventEntity';
  attributes: Maybe<ChatEvent>;
  id: Maybe<Scalars['ID']>;
};

export type ChatEventEntityResponse = {
  __typename?: 'ChatEventEntityResponse';
  data: Maybe<ChatEventEntity>;
};

export type ChatEventEntityResponseCollection = {
  __typename?: 'ChatEventEntityResponseCollection';
  data: Array<ChatEventEntity>;
  meta: ResponseCollectionMeta;
};

export type ChatEventFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ChatEventFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  group: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<ChatEventFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ChatEventFiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type ChatEventInput = {
  chatMessages: InputMaybe<Array<Scalars['ChatEventChatMessagesDynamicZoneInput']>>;
  group: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

export type ChatStele = {
  __typename?: 'ChatStele';
  background: ComponentGeneralImage;
  backgroundVideoSrc: Scalars['String'];
  button: ComponentGeneralButton;
  callTerminatedTimerText: Scalars['String'];
  cityViewLoopVideo: ComponentGeneralImage;
  cityViewTransitionVideo: ComponentGeneralImage;
  connectionLostEndOfChat: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  endOfCallLoadingSpinner: ComponentGeneralImage;
  livingRoomLoopVideo: ComponentGeneralImage;
  livingRoomTransitionVideo: ComponentGeneralImage;
  loadingSpinner: Maybe<ComponentGeneralImage>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<ChatSteleRelationResponseCollection>;
  placeholderOldFutureMe: ComponentGeneralImage;
  projectionBackgroundVideo: ComponentGeneralImage;
  selfieBackground: Maybe<ComponentGeneralImage>;
  selfieBranding: Maybe<ComponentGeneralImage>;
  selfieIcon: Maybe<ComponentGeneralImage>;
  timeForCallTerminationEndChat: Scalars['Long'];
  timeForCallTerminationMidChat: Scalars['Long'];
  timeTillTotalReset: Scalars['Long'];
  timeoutAfterStillThereTillCallTerminationTimerStarts: Maybe<Scalars['Long']>;
  timeoutTillConnectionLostMessage: Maybe<Scalars['Long']>;
  timeoutTillStillThereMessage: Scalars['Long'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ChatSteleEntity = {
  __typename?: 'ChatSteleEntity';
  attributes: Maybe<ChatStele>;
  id: Maybe<Scalars['ID']>;
};

export type ChatSteleEntityResponse = {
  __typename?: 'ChatSteleEntityResponse';
  data: Maybe<ChatSteleEntity>;
};

export type ChatSteleInput = {
  background: InputMaybe<ComponentGeneralImageInput>;
  backgroundVideoSrc: InputMaybe<Scalars['String']>;
  button: InputMaybe<ComponentGeneralButtonInput>;
  callTerminatedTimerText: InputMaybe<Scalars['String']>;
  cityViewLoopVideo: InputMaybe<ComponentGeneralImageInput>;
  cityViewTransitionVideo: InputMaybe<ComponentGeneralImageInput>;
  connectionLostEndOfChat: InputMaybe<Scalars['String']>;
  endOfCallLoadingSpinner: InputMaybe<ComponentGeneralImageInput>;
  livingRoomLoopVideo: InputMaybe<ComponentGeneralImageInput>;
  livingRoomTransitionVideo: InputMaybe<ComponentGeneralImageInput>;
  loadingSpinner: InputMaybe<ComponentGeneralImageInput>;
  placeholderOldFutureMe: InputMaybe<ComponentGeneralImageInput>;
  projectionBackgroundVideo: InputMaybe<ComponentGeneralImageInput>;
  selfieBackground: InputMaybe<ComponentGeneralImageInput>;
  selfieBranding: InputMaybe<ComponentGeneralImageInput>;
  selfieIcon: InputMaybe<ComponentGeneralImageInput>;
  timeForCallTerminationEndChat: InputMaybe<Scalars['Long']>;
  timeForCallTerminationMidChat: InputMaybe<Scalars['Long']>;
  timeTillTotalReset: InputMaybe<Scalars['Long']>;
  timeoutAfterStillThereTillCallTerminationTimerStarts: InputMaybe<Scalars['Long']>;
  timeoutTillConnectionLostMessage: InputMaybe<Scalars['Long']>;
  timeoutTillStillThereMessage: InputMaybe<Scalars['Long']>;
};

export type ChatSteleRelationResponseCollection = {
  __typename?: 'ChatSteleRelationResponseCollection';
  data: Array<ChatSteleEntity>;
};

export type Chatbot = {
  __typename?: 'Chatbot';
  behindChatBg: ComponentGeneralImage;
  cancelCallLinkTitle: Scalars['String'];
  cancelCallLinkUrl: Scalars['String'];
  chatInputSendIcon: ComponentGeneralImage;
  chatWritingGif: ComponentGeneralImage;
  chatbotPrompt: Scalars['String'];
  cityViewLoopVideo: ComponentGeneralImage;
  cityViewTransitionVideo: ComponentGeneralImage;
  createdAt: Maybe<Scalars['DateTime']>;
  defaultBackgroundVideo: ComponentGeneralImage;
  faceRecognitionHintBulletPoints: Array<Maybe<ComponentGeneralBulletPoint>>;
  grantPermissionButtonIcon: ComponentGeneralImage;
  grantPermissionButtonText: Scalars['String'];
  inputDefaultValue: Scalars['String'];
  keyvisualDark320px: ComponentGeneralImage;
  keyvisualDark480px: ComponentGeneralImage;
  keyvisualDark768px: ComponentGeneralImage;
  keyvisualDark1024px: ComponentGeneralImage;
  keyvisualDark1280px: ComponentGeneralImage;
  keyvisualDark1920px: ComponentGeneralImage;
  landingBg320px: ComponentGeneralImage;
  landingBg480px: ComponentGeneralImage;
  landingBg768px: ComponentGeneralImage;
  landingBg1024px: ComponentGeneralImage;
  landingBg1280px: ComponentGeneralImage;
  landingBg1920px: ComponentGeneralImage;
  landscapeWarningBackground: ComponentGeneralImage;
  landscapeWarningHintIcon: ComponentGeneralImage;
  landscapeWarningHintText: Maybe<Scalars['String']>;
  linkPageButtonOne: ComponentGeneralButton;
  linkPageButtonTwo: ComponentGeneralButton;
  linkPageCardDescription: Scalars['String'];
  linkPageCardTitle: Scalars['String'];
  livingRoomLoopVideo: ComponentGeneralImage;
  livingRoomTransitionVideo: ComponentGeneralImage;
  loadingConnectionLostButton: ComponentGeneralButton;
  loadingConnectionLostText: Scalars['String'];
  loadingKiHintText: Scalars['String'];
  loadingProcessingAbortedButton: ComponentGeneralButton;
  loadingProcessingAbortedText: Scalars['String'];
  loadingQueueText: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<ChatbotRelationResponseCollection>;
  maskFaceNotDetectedHint: Scalars['String'];
  maskFaceNotDetectedHintIcon: ComponentGeneralImage;
  noCameraAccessIcon: ComponentGeneralImage;
  noCameraAccessText: Scalars['String'];
  positionInQueueText: Scalars['String'];
  processingAbortedText: Scalars['String'];
  projectionBackground: Maybe<ComponentGeneralImage>;
  projectionForeground: Maybe<ComponentGeneralImage>;
  restartButtonLoading: ComponentGeneralButton;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type ChatbotFaceRecognitionHintBulletPointsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ChatbotEntity = {
  __typename?: 'ChatbotEntity';
  attributes: Maybe<Chatbot>;
  id: Maybe<Scalars['ID']>;
};

export type ChatbotEntityResponse = {
  __typename?: 'ChatbotEntityResponse';
  data: Maybe<ChatbotEntity>;
};

export type ChatbotInput = {
  behindChatBg: InputMaybe<ComponentGeneralImageInput>;
  cancelCallLinkTitle: InputMaybe<Scalars['String']>;
  cancelCallLinkUrl: InputMaybe<Scalars['String']>;
  chatInputSendIcon: InputMaybe<ComponentGeneralImageInput>;
  chatWritingGif: InputMaybe<ComponentGeneralImageInput>;
  chatbotPrompt: InputMaybe<Scalars['String']>;
  cityViewLoopVideo: InputMaybe<ComponentGeneralImageInput>;
  cityViewTransitionVideo: InputMaybe<ComponentGeneralImageInput>;
  defaultBackgroundVideo: InputMaybe<ComponentGeneralImageInput>;
  faceRecognitionHintBulletPoints: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  grantPermissionButtonIcon: InputMaybe<ComponentGeneralImageInput>;
  grantPermissionButtonText: InputMaybe<Scalars['String']>;
  inputDefaultValue: InputMaybe<Scalars['String']>;
  keyvisualDark320px: InputMaybe<ComponentGeneralImageInput>;
  keyvisualDark480px: InputMaybe<ComponentGeneralImageInput>;
  keyvisualDark768px: InputMaybe<ComponentGeneralImageInput>;
  keyvisualDark1024px: InputMaybe<ComponentGeneralImageInput>;
  keyvisualDark1280px: InputMaybe<ComponentGeneralImageInput>;
  keyvisualDark1920px: InputMaybe<ComponentGeneralImageInput>;
  landingBg320px: InputMaybe<ComponentGeneralImageInput>;
  landingBg480px: InputMaybe<ComponentGeneralImageInput>;
  landingBg768px: InputMaybe<ComponentGeneralImageInput>;
  landingBg1024px: InputMaybe<ComponentGeneralImageInput>;
  landingBg1280px: InputMaybe<ComponentGeneralImageInput>;
  landingBg1920px: InputMaybe<ComponentGeneralImageInput>;
  landscapeWarningBackground: InputMaybe<ComponentGeneralImageInput>;
  landscapeWarningHintIcon: InputMaybe<ComponentGeneralImageInput>;
  landscapeWarningHintText: InputMaybe<Scalars['String']>;
  linkPageButtonOne: InputMaybe<ComponentGeneralButtonInput>;
  linkPageButtonTwo: InputMaybe<ComponentGeneralButtonInput>;
  linkPageCardDescription: InputMaybe<Scalars['String']>;
  linkPageCardTitle: InputMaybe<Scalars['String']>;
  livingRoomLoopVideo: InputMaybe<ComponentGeneralImageInput>;
  livingRoomTransitionVideo: InputMaybe<ComponentGeneralImageInput>;
  loadingConnectionLostButton: InputMaybe<ComponentGeneralButtonInput>;
  loadingConnectionLostText: InputMaybe<Scalars['String']>;
  loadingKiHintText: InputMaybe<Scalars['String']>;
  loadingProcessingAbortedButton: InputMaybe<ComponentGeneralButtonInput>;
  loadingProcessingAbortedText: InputMaybe<Scalars['String']>;
  loadingQueueText: InputMaybe<Scalars['String']>;
  maskFaceNotDetectedHint: InputMaybe<Scalars['String']>;
  maskFaceNotDetectedHintIcon: InputMaybe<ComponentGeneralImageInput>;
  noCameraAccessIcon: InputMaybe<ComponentGeneralImageInput>;
  noCameraAccessText: InputMaybe<Scalars['String']>;
  positionInQueueText: InputMaybe<Scalars['String']>;
  processingAbortedText: InputMaybe<Scalars['String']>;
  projectionBackground: InputMaybe<ComponentGeneralImageInput>;
  projectionForeground: InputMaybe<ComponentGeneralImageInput>;
  restartButtonLoading: InputMaybe<ComponentGeneralButtonInput>;
};

export type ChatbotRelationResponseCollection = {
  __typename?: 'ChatbotRelationResponseCollection';
  data: Array<ChatbotEntity>;
};

export type ComingSoon = {
  __typename?: 'ComingSoon';
  cardLink: Scalars['String'];
  cardSubtitle: Scalars['String'];
  cardTitle: Scalars['String'];
  claim: ComponentGeneralImage;
  createdAt: Maybe<Scalars['DateTime']>;
  heroDesktop: ComponentGeneralImage;
  heroMobile: ComponentGeneralImage;
  link: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<ComingSoonRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ComingSoonEntity = {
  __typename?: 'ComingSoonEntity';
  attributes: Maybe<ComingSoon>;
  id: Maybe<Scalars['ID']>;
};

export type ComingSoonEntityResponse = {
  __typename?: 'ComingSoonEntityResponse';
  data: Maybe<ComingSoonEntity>;
};

export type ComingSoonInput = {
  cardLink: InputMaybe<Scalars['String']>;
  cardSubtitle: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
  claim: InputMaybe<ComponentGeneralImageInput>;
  heroDesktop: InputMaybe<ComponentGeneralImageInput>;
  heroMobile: InputMaybe<ComponentGeneralImageInput>;
  link: InputMaybe<Scalars['String']>;
};

export type ComingSoonRelationResponseCollection = {
  __typename?: 'ComingSoonRelationResponseCollection';
  data: Array<ComingSoonEntity>;
};

export type ComponentChatMessageAiChat = {
  __typename?: 'ComponentChatMessageAiChat';
  id: Scalars['ID'];
  parameters: ComponentChatMessageParameters;
};

export type ComponentChatMessageButton = {
  __typename?: 'ComponentChatMessageButton';
  chat_branch: Maybe<ChatBranchEntityResponse>;
  chat_branch_ai: Maybe<ChatBranchAiEntityResponse>;
  chat_event: Maybe<ChatEventEntityResponse>;
  emojiAlt: Maybe<Scalars['String']>;
  emojiImg: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  isGptQuestion: Maybe<Scalars['Boolean']>;
  label: Maybe<I18NEntityResponse>;
  name: Maybe<Scalars['String']>;
  text: Maybe<I18NEntityResponse>;
};

export type ComponentChatMessageButtonFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentChatMessageButtonFiltersInput>>>;
  chat_branch: InputMaybe<ChatBranchFiltersInput>;
  chat_branch_ai: InputMaybe<ChatBranchAiFiltersInput>;
  chat_event: InputMaybe<ChatEventFiltersInput>;
  emojiAlt: InputMaybe<StringFilterInput>;
  isGptQuestion: InputMaybe<BooleanFilterInput>;
  label: InputMaybe<I18NFiltersInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<ComponentChatMessageButtonFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentChatMessageButtonFiltersInput>>>;
  text: InputMaybe<I18NFiltersInput>;
};

export type ComponentChatMessageButtonGroup = {
  __typename?: 'ComponentChatMessageButtonGroup';
  buttons: Maybe<Array<Maybe<ComponentChatMessageButton>>>;
  hasGptInput: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  parameters: ComponentChatMessageParameters;
};


export type ComponentChatMessageButtonGroupButtonsArgs = {
  filters: InputMaybe<ComponentChatMessageButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentChatMessageGoToBranch = {
  __typename?: 'ComponentChatMessageGoToBranch';
  chat_branch: Maybe<ChatBranchEntityResponse>;
  chat_branch_ai: Maybe<ChatBranchAiEntityResponse>;
  chat_event: Maybe<ChatEventEntityResponse>;
  id: Scalars['ID'];
  parameters: ComponentChatMessageParameters;
};

export type ComponentChatMessageImage = {
  __typename?: 'ComponentChatMessageImage';
  altText: Maybe<I18NEntityResponse>;
  cta_close: Maybe<I18NEntityResponse>;
  cta_enlarge: Maybe<I18NEntityResponse>;
  dynamic_source: Maybe<Enum_Componentchatmessageimage_Dynamic_Source>;
  id: Scalars['ID'];
  image: Maybe<UploadFileEntityResponse>;
  name: Maybe<Scalars['String']>;
  parameters: ComponentChatMessageParameters;
  text: Maybe<I18NEntityResponse>;
  text_enlarged: Maybe<I18NEntityResponse>;
};

export type ComponentChatMessageLink = {
  __typename?: 'ComponentChatMessageLink';
  altText: Maybe<I18NEntityResponse>;
  id: Scalars['ID'];
  image: Maybe<UploadFileEntityResponse>;
  link_title: Maybe<I18NEntityResponse>;
  link_url: Maybe<I18NEntityResponse>;
  name: Maybe<Scalars['String']>;
  parameters: ComponentChatMessageParameters;
  title: Maybe<I18NEntityResponse>;
};

export type ComponentChatMessageParameters = {
  __typename?: 'ComponentChatMessageParameters';
  delay: Scalars['Float'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  switchBackground: Maybe<Enum_Componentchatmessageparameters_Switchbackground>;
  triggerEffect: Maybe<Enum_Componentchatmessageparameters_Triggereffect>;
};

export type ComponentChatMessageText = {
  __typename?: 'ComponentChatMessageText';
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  parameters: ComponentChatMessageParameters;
  text: Maybe<I18NEntityResponse>;
};

export type ComponentChatMessageTextAi = {
  __typename?: 'ComponentChatMessageTextAi';
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  parameters: ComponentChatMessageParameters;
  question: Maybe<I18NEntityResponse>;
};

export type ComponentGeneralAccordion = {
  __typename?: 'ComponentGeneralAccordion';
  content: Scalars['String'];
  id: Scalars['ID'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  titleIcon: ComponentGeneralImage;
};

export type ComponentGeneralAccordionFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralAccordionFiltersInput>>>;
  content: InputMaybe<StringFilterInput>;
  not: InputMaybe<ComponentGeneralAccordionFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralAccordionFiltersInput>>>;
  subtitle: InputMaybe<StringFilterInput>;
  title: InputMaybe<StringFilterInput>;
  titleIcon: InputMaybe<ComponentGeneralImageFiltersInput>;
};

export type ComponentGeneralAccordionInput = {
  content: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['ID']>;
  subtitle: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  titleIcon: InputMaybe<ComponentGeneralImageInput>;
};

export type ComponentGeneralBulletPoint = {
  __typename?: 'ComponentGeneralBulletPoint';
  icon: Maybe<ComponentGeneralImage>;
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type ComponentGeneralBulletPointFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointFiltersInput>>>;
  icon: InputMaybe<ComponentGeneralImageFiltersInput>;
  not: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointFiltersInput>>>;
  text: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralBulletPointInput = {
  icon: InputMaybe<ComponentGeneralImageInput>;
  id: InputMaybe<Scalars['ID']>;
  text: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralButton = {
  __typename?: 'ComponentGeneralButton';
  disabledIcon: Maybe<ComponentGeneralImage>;
  icon: Maybe<ComponentGeneralImage>;
  id: Scalars['ID'];
  text: Maybe<Scalars['String']>;
};

export type ComponentGeneralButtonInput = {
  disabledIcon: InputMaybe<ComponentGeneralImageInput>;
  icon: InputMaybe<ComponentGeneralImageInput>;
  id: InputMaybe<Scalars['ID']>;
  text: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralButtonLink = {
  __typename?: 'ComponentGeneralButtonLink';
  icon: Maybe<ComponentGeneralImage>;
  id: Scalars['ID'];
  link: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentGeneralButtonLinkInput = {
  icon: InputMaybe<ComponentGeneralImageInput>;
  id: InputMaybe<Scalars['ID']>;
  link: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralCardBenefit = {
  __typename?: 'ComponentGeneralCardBenefit';
  icon: ComponentGeneralImage;
  id: Scalars['ID'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentGeneralCardBenefitFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralCardBenefitFiltersInput>>>;
  icon: InputMaybe<ComponentGeneralImageFiltersInput>;
  not: InputMaybe<ComponentGeneralCardBenefitFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralCardBenefitFiltersInput>>>;
  subtitle: InputMaybe<StringFilterInput>;
  title: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralCardBenefitInput = {
  icon: InputMaybe<ComponentGeneralImageInput>;
  id: InputMaybe<Scalars['ID']>;
  subtitle: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralDropdown = {
  __typename?: 'ComponentGeneralDropdown';
  content: Scalars['String'];
  id: Scalars['ID'];
  link: Maybe<Scalars['String']>;
  linkIcon: Maybe<ComponentGeneralImage>;
  title: Scalars['String'];
};

export type ComponentGeneralDropdownFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralDropdownFiltersInput>>>;
  content: InputMaybe<StringFilterInput>;
  link: InputMaybe<StringFilterInput>;
  linkIcon: InputMaybe<ComponentGeneralImageFiltersInput>;
  not: InputMaybe<ComponentGeneralDropdownFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralDropdownFiltersInput>>>;
  title: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralDropdownInput = {
  content: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['ID']>;
  link: InputMaybe<Scalars['String']>;
  linkIcon: InputMaybe<ComponentGeneralImageInput>;
  title: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralImage = {
  __typename?: 'ComponentGeneralImage';
  altText: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: Maybe<UploadFileEntityResponse>;
  imageHD: Maybe<UploadFileEntityResponse>;
};

export type ComponentGeneralImageFiltersInput = {
  altText: InputMaybe<StringFilterInput>;
  and: InputMaybe<Array<InputMaybe<ComponentGeneralImageFiltersInput>>>;
  not: InputMaybe<ComponentGeneralImageFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralImageFiltersInput>>>;
};

export type ComponentGeneralImageInput = {
  altText: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['ID']>;
  image: InputMaybe<Scalars['ID']>;
  imageHD: InputMaybe<Scalars['ID']>;
};

export type ComponentGeneralLink = {
  __typename?: 'ComponentGeneralLink';
  id: Scalars['ID'];
  label: Scalars['String'];
  link: Scalars['String'];
};

export type ComponentGeneralLinkList = {
  __typename?: 'ComponentGeneralLinkList';
  id: Scalars['ID'];
  link: Maybe<Scalars['String']>;
  linkHomepage: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentGeneralLinkListFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralLinkListFiltersInput>>>;
  link: InputMaybe<StringFilterInput>;
  linkHomepage: InputMaybe<StringFilterInput>;
  not: InputMaybe<ComponentGeneralLinkListFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralLinkListFiltersInput>>>;
  title: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralLinkListInput = {
  id: InputMaybe<Scalars['ID']>;
  link: InputMaybe<Scalars['String']>;
  linkHomepage: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
};

export type ComponentGeneralList = {
  __typename?: 'ComponentGeneralList';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ComponentGeneralListFiltersInput = {
  and: InputMaybe<Array<InputMaybe<ComponentGeneralListFiltersInput>>>;
  not: InputMaybe<ComponentGeneralListFiltersInput>;
  or: InputMaybe<Array<InputMaybe<ComponentGeneralListFiltersInput>>>;
  title: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralListInput = {
  id: InputMaybe<Scalars['ID']>;
  title: InputMaybe<Scalars['String']>;
};

export type ComponentPostProcessingImage = {
  __typename?: 'ComponentPostProcessingImage';
  id: Scalars['ID'];
  image: Maybe<UploadFileEntityResponse>;
};

export type ComponentPostProcessingVideo = {
  __typename?: 'ComponentPostProcessingVideo';
  id: Scalars['ID'];
  video: Maybe<UploadFileEntityResponse>;
  videoHD: Maybe<UploadFileEntityResponse>;
};

export type ComponentPostProcessingVideoInput = {
  id: InputMaybe<Scalars['ID']>;
  video: InputMaybe<Scalars['ID']>;
  videoHD: InputMaybe<Scalars['ID']>;
};

export type DateTimeFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains: InputMaybe<Scalars['DateTime']>;
  containsi: InputMaybe<Scalars['DateTime']>;
  endsWith: InputMaybe<Scalars['DateTime']>;
  eq: InputMaybe<Scalars['DateTime']>;
  eqi: InputMaybe<Scalars['DateTime']>;
  gt: InputMaybe<Scalars['DateTime']>;
  gte: InputMaybe<Scalars['DateTime']>;
  in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt: InputMaybe<Scalars['DateTime']>;
  lte: InputMaybe<Scalars['DateTime']>;
  ne: InputMaybe<Scalars['DateTime']>;
  not: InputMaybe<DateTimeFilterInput>;
  notContains: InputMaybe<Scalars['DateTime']>;
  notContainsi: InputMaybe<Scalars['DateTime']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith: InputMaybe<Scalars['DateTime']>;
};

export enum Enum_Componentchatmessageimage_Dynamic_Source {
  NotDynamic = 'not_dynamic',
  Selfie = 'selfie'
}

export enum Enum_Componentchatmessageparameters_Switchbackground {
  Connecting = 'connecting',
  ConnectionLost = 'connection_lost',
  FaceToFace = 'face_to_face',
  InsideHome = 'inside_home',
  OutsideHome = 'outside_home',
  Selfie = 'selfie'
}

export enum Enum_Componentchatmessageparameters_Triggereffect {
  Confetti = 'confetti',
  Glitching = 'glitching',
  Hearts = 'hearts',
  Laser = 'laser',
  LastBranch = 'lastBranch',
  LastMessage = 'lastMessage'
}

export type EndOfCallOld = {
  __typename?: 'EndOfCallOld';
  cardDescription: Scalars['String'];
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<EndOfCallOldRelationResponseCollection>;
  qrCode: ComponentGeneralImage;
  qrCodeSubtitle: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type EndOfCallOldEntity = {
  __typename?: 'EndOfCallOldEntity';
  attributes: Maybe<EndOfCallOld>;
  id: Maybe<Scalars['ID']>;
};

export type EndOfCallOldEntityResponse = {
  __typename?: 'EndOfCallOldEntityResponse';
  data: Maybe<EndOfCallOldEntity>;
};

export type EndOfCallOldInput = {
  cardDescription: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
  qrCode: InputMaybe<ComponentGeneralImageInput>;
  qrCodeSubtitle: InputMaybe<Scalars['String']>;
};

export type EndOfCallOldRelationResponseCollection = {
  __typename?: 'EndOfCallOldRelationResponseCollection';
  data: Array<EndOfCallOldEntity>;
};

export type EndOfCallRegular = {
  __typename?: 'EndOfCallRegular';
  button: Scalars['String'];
  cardDescription: Scalars['String'];
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<EndOfCallRegularRelationResponseCollection>;
  qrCode: ComponentGeneralImage;
  qrCodeHint: Scalars['String'];
  qrCodeSubtitle: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type EndOfCallRegularEntity = {
  __typename?: 'EndOfCallRegularEntity';
  attributes: Maybe<EndOfCallRegular>;
  id: Maybe<Scalars['ID']>;
};

export type EndOfCallRegularEntityResponse = {
  __typename?: 'EndOfCallRegularEntityResponse';
  data: Maybe<EndOfCallRegularEntity>;
};

export type EndOfCallRegularInput = {
  button: InputMaybe<Scalars['String']>;
  cardDescription: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
  qrCode: InputMaybe<ComponentGeneralImageInput>;
  qrCodeHint: InputMaybe<Scalars['String']>;
  qrCodeSubtitle: InputMaybe<Scalars['String']>;
};

export type EndOfCallRegularRelationResponseCollection = {
  __typename?: 'EndOfCallRegularRelationResponseCollection';
  data: Array<EndOfCallRegularEntity>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  alternativeText: InputMaybe<Scalars['String']>;
  caption: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains: InputMaybe<Scalars['Float']>;
  containsi: InputMaybe<Scalars['Float']>;
  endsWith: InputMaybe<Scalars['Float']>;
  eq: InputMaybe<Scalars['Float']>;
  eqi: InputMaybe<Scalars['Float']>;
  gt: InputMaybe<Scalars['Float']>;
  gte: InputMaybe<Scalars['Float']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt: InputMaybe<Scalars['Float']>;
  lte: InputMaybe<Scalars['Float']>;
  ne: InputMaybe<Scalars['Float']>;
  not: InputMaybe<FloatFilterInput>;
  notContains: InputMaybe<Scalars['Float']>;
  notContainsi: InputMaybe<Scalars['Float']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = Age | CancelCall | ChatBranch | ChatBranchAi | ChatBranchOver50 | ChatEvent | ChatStele | Chatbot | ComingSoon | ComponentChatMessageAiChat | ComponentChatMessageButton | ComponentChatMessageButtonGroup | ComponentChatMessageGoToBranch | ComponentChatMessageImage | ComponentChatMessageLink | ComponentChatMessageParameters | ComponentChatMessageText | ComponentChatMessageTextAi | ComponentGeneralAccordion | ComponentGeneralBulletPoint | ComponentGeneralButton | ComponentGeneralButtonLink | ComponentGeneralCardBenefit | ComponentGeneralDropdown | ComponentGeneralImage | ComponentGeneralLink | ComponentGeneralLinkList | ComponentGeneralList | ComponentPostProcessingImage | ComponentPostProcessingVideo | EndOfCallOld | EndOfCallRegular | Global | GlobalEvent | Hint | I18N | I18NLocale | Imprint | Landing | Loading | Mask | Meta | PageNotFound | PostProcessing | PrivacyPolicy | Start | Tutorial | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Global = {
  __typename?: 'Global';
  createdAt: Maybe<Scalars['DateTime']>;
  dataProtectionInformation: Scalars['String'];
  heartEffect: ComponentGeneralImage;
  imprint: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<GlobalRelationResponseCollection>;
  logo: ComponentGeneralImage;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type GlobalEntity = {
  __typename?: 'GlobalEntity';
  attributes: Maybe<Global>;
  id: Maybe<Scalars['ID']>;
};

export type GlobalEntityResponse = {
  __typename?: 'GlobalEntityResponse';
  data: Maybe<GlobalEntity>;
};

export type GlobalEvent = {
  __typename?: 'GlobalEvent';
  createdAt: Maybe<Scalars['DateTime']>;
  landingButton1: ComponentGeneralButton;
  landingButton2: ComponentGeneralButton;
  loadingInfoCall: Scalars['String'];
  loadingInfoSelfie: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<GlobalEventRelationResponseCollection>;
  maskButtonCall: ComponentGeneralButton;
  maskButtonSelfie: ComponentGeneralButton;
  neueLebenWatermark: ComponentGeneralImage;
  selfieBackground: ComponentGeneralImage;
  selfieCloseFullscreen: ComponentGeneralButton;
  selfieModalButton1: ComponentGeneralButton;
  selfieModalButton2: ComponentGeneralButton;
  selfieModalQRCodeNL: ComponentGeneralImage;
  selfieModalQRCodeNLInfo: Scalars['String'];
  selfieModalQrCodeText: Scalars['String'];
  selfieQrCodeScan: ComponentGeneralImage;
  selfieScanCode: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type GlobalEventEntity = {
  __typename?: 'GlobalEventEntity';
  attributes: Maybe<GlobalEvent>;
  id: Maybe<Scalars['ID']>;
};

export type GlobalEventEntityResponse = {
  __typename?: 'GlobalEventEntityResponse';
  data: Maybe<GlobalEventEntity>;
};

export type GlobalEventInput = {
  landingButton1: InputMaybe<ComponentGeneralButtonInput>;
  landingButton2: InputMaybe<ComponentGeneralButtonInput>;
  loadingInfoCall: InputMaybe<Scalars['String']>;
  loadingInfoSelfie: InputMaybe<Scalars['String']>;
  maskButtonCall: InputMaybe<ComponentGeneralButtonInput>;
  maskButtonSelfie: InputMaybe<ComponentGeneralButtonInput>;
  neueLebenWatermark: InputMaybe<ComponentGeneralImageInput>;
  selfieBackground: InputMaybe<ComponentGeneralImageInput>;
  selfieCloseFullscreen: InputMaybe<ComponentGeneralButtonInput>;
  selfieModalButton1: InputMaybe<ComponentGeneralButtonInput>;
  selfieModalButton2: InputMaybe<ComponentGeneralButtonInput>;
  selfieModalQRCodeNL: InputMaybe<ComponentGeneralImageInput>;
  selfieModalQRCodeNLInfo: InputMaybe<Scalars['String']>;
  selfieModalQrCodeText: InputMaybe<Scalars['String']>;
  selfieQrCodeScan: InputMaybe<ComponentGeneralImageInput>;
  selfieScanCode: InputMaybe<Scalars['String']>;
};

export type GlobalEventRelationResponseCollection = {
  __typename?: 'GlobalEventRelationResponseCollection';
  data: Array<GlobalEventEntity>;
};

export type GlobalInput = {
  dataProtectionInformation: InputMaybe<Scalars['String']>;
  heartEffect: InputMaybe<ComponentGeneralImageInput>;
  imprint: InputMaybe<Scalars['String']>;
  logo: InputMaybe<ComponentGeneralImageInput>;
};

export type GlobalRelationResponseCollection = {
  __typename?: 'GlobalRelationResponseCollection';
  data: Array<GlobalEntity>;
};

export type Hint = {
  __typename?: 'Hint';
  bulletPoints: Array<Maybe<ComponentGeneralBulletPoint>>;
  buttonOne: ComponentGeneralButton;
  buttonTwo: ComponentGeneralButton;
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<HintRelationResponseCollection>;
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type HintBulletPointsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HintEntity = {
  __typename?: 'HintEntity';
  attributes: Maybe<Hint>;
  id: Maybe<Scalars['ID']>;
};

export type HintEntityResponse = {
  __typename?: 'HintEntityResponse';
  data: Maybe<HintEntity>;
};

export type HintInput = {
  bulletPoints: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  buttonOne: InputMaybe<ComponentGeneralButtonInput>;
  buttonTwo: InputMaybe<ComponentGeneralButtonInput>;
  title: InputMaybe<Scalars['String']>;
};

export type HintRelationResponseCollection = {
  __typename?: 'HintRelationResponseCollection';
  data: Array<HintEntity>;
};

export type I18N = {
  __typename?: 'I18N';
  createdAt: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<I18NRelationResponseCollection>;
  translation: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type I18NLocalizationsArgs = {
  filters: InputMaybe<I18NFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type I18NEntity = {
  __typename?: 'I18NEntity';
  attributes: Maybe<I18N>;
  id: Maybe<Scalars['ID']>;
};

export type I18NEntityResponse = {
  __typename?: 'I18NEntityResponse';
  data: Maybe<I18NEntity>;
};

export type I18NEntityResponseCollection = {
  __typename?: 'I18NEntityResponseCollection';
  data: Array<I18NEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NFiltersInput = {
  and: InputMaybe<Array<InputMaybe<I18NFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  id: InputMaybe<IdFilterInput>;
  key: InputMaybe<StringFilterInput>;
  locale: InputMaybe<StringFilterInput>;
  localizations: InputMaybe<I18NFiltersInput>;
  not: InputMaybe<I18NFiltersInput>;
  or: InputMaybe<Array<InputMaybe<I18NFiltersInput>>>;
  translation: InputMaybe<StringFilterInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type I18NInput = {
  key: InputMaybe<Scalars['String']>;
  translation: InputMaybe<Scalars['String']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes: Maybe<I18NLocale>;
  id: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code: InputMaybe<StringFilterInput>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<I18NLocaleFiltersInput>;
  or: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type I18NRelationResponseCollection = {
  __typename?: 'I18NRelationResponseCollection';
  data: Array<I18NEntity>;
};

export type IdFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains: InputMaybe<Scalars['ID']>;
  containsi: InputMaybe<Scalars['ID']>;
  endsWith: InputMaybe<Scalars['ID']>;
  eq: InputMaybe<Scalars['ID']>;
  eqi: InputMaybe<Scalars['ID']>;
  gt: InputMaybe<Scalars['ID']>;
  gte: InputMaybe<Scalars['ID']>;
  in: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt: InputMaybe<Scalars['ID']>;
  lte: InputMaybe<Scalars['ID']>;
  ne: InputMaybe<Scalars['ID']>;
  not: InputMaybe<IdFilterInput>;
  notContains: InputMaybe<Scalars['ID']>;
  notContainsi: InputMaybe<Scalars['ID']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith: InputMaybe<Scalars['ID']>;
};

export type Imprint = {
  __typename?: 'Imprint';
  background: ComponentGeneralImage;
  button: ComponentGeneralButton;
  cardContent: Scalars['String'];
  cardEMail: Scalars['String'];
  cardFaxNumber: Scalars['String'];
  cardLocation: Scalars['String'];
  cardPhoneNumber: Scalars['String'];
  cardStreet: Maybe<Scalars['String']>;
  cardSubtitle: Scalars['String'];
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<ImprintRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ImprintEntity = {
  __typename?: 'ImprintEntity';
  attributes: Maybe<Imprint>;
  id: Maybe<Scalars['ID']>;
};

export type ImprintEntityResponse = {
  __typename?: 'ImprintEntityResponse';
  data: Maybe<ImprintEntity>;
};

export type ImprintInput = {
  background: InputMaybe<ComponentGeneralImageInput>;
  button: InputMaybe<ComponentGeneralButtonInput>;
  cardContent: InputMaybe<Scalars['String']>;
  cardEMail: InputMaybe<Scalars['String']>;
  cardFaxNumber: InputMaybe<Scalars['String']>;
  cardLocation: InputMaybe<Scalars['String']>;
  cardPhoneNumber: InputMaybe<Scalars['String']>;
  cardStreet: InputMaybe<Scalars['String']>;
  cardSubtitle: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
};

export type ImprintRelationResponseCollection = {
  __typename?: 'ImprintRelationResponseCollection';
  data: Array<ImprintEntity>;
};

export type IntFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains: InputMaybe<Scalars['Int']>;
  containsi: InputMaybe<Scalars['Int']>;
  endsWith: InputMaybe<Scalars['Int']>;
  eq: InputMaybe<Scalars['Int']>;
  eqi: InputMaybe<Scalars['Int']>;
  gt: InputMaybe<Scalars['Int']>;
  gte: InputMaybe<Scalars['Int']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt: InputMaybe<Scalars['Int']>;
  lte: InputMaybe<Scalars['Int']>;
  ne: InputMaybe<Scalars['Int']>;
  not: InputMaybe<IntFilterInput>;
  notContains: InputMaybe<Scalars['Int']>;
  notContainsi: InputMaybe<Scalars['Int']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains: InputMaybe<Scalars['JSON']>;
  containsi: InputMaybe<Scalars['JSON']>;
  endsWith: InputMaybe<Scalars['JSON']>;
  eq: InputMaybe<Scalars['JSON']>;
  eqi: InputMaybe<Scalars['JSON']>;
  gt: InputMaybe<Scalars['JSON']>;
  gte: InputMaybe<Scalars['JSON']>;
  in: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt: InputMaybe<Scalars['JSON']>;
  lte: InputMaybe<Scalars['JSON']>;
  ne: InputMaybe<Scalars['JSON']>;
  not: InputMaybe<JsonFilterInput>;
  notContains: InputMaybe<Scalars['JSON']>;
  notContainsi: InputMaybe<Scalars['JSON']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith: InputMaybe<Scalars['JSON']>;
};

export type Landing = {
  __typename?: 'Landing';
  background: ComponentGeneralImage;
  backgroundVideo: ComponentPostProcessingVideo;
  buttonOne: ComponentGeneralButton;
  buttonTwo: ComponentGeneralButton;
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<LandingRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type LandingEntity = {
  __typename?: 'LandingEntity';
  attributes: Maybe<Landing>;
  id: Maybe<Scalars['ID']>;
};

export type LandingEntityResponse = {
  __typename?: 'LandingEntityResponse';
  data: Maybe<LandingEntity>;
};

export type LandingInput = {
  background: InputMaybe<ComponentGeneralImageInput>;
  backgroundVideo: InputMaybe<ComponentPostProcessingVideoInput>;
  buttonOne: InputMaybe<ComponentGeneralButtonInput>;
  buttonTwo: InputMaybe<ComponentGeneralButtonInput>;
};

export type LandingRelationResponseCollection = {
  __typename?: 'LandingRelationResponseCollection';
  data: Array<LandingEntity>;
};

export type Loading = {
  __typename?: 'Loading';
  background: ComponentPostProcessingVideo;
  checkAfterSpinner: Maybe<ComponentGeneralImage>;
  connectionAnimation: ComponentGeneralImage;
  createdAt: Maybe<Scalars['DateTime']>;
  loadingTexts: Array<Maybe<ComponentGeneralList>>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<LoadingRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type LoadingLoadingTextsArgs = {
  filters: InputMaybe<ComponentGeneralListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LoadingEntity = {
  __typename?: 'LoadingEntity';
  attributes: Maybe<Loading>;
  id: Maybe<Scalars['ID']>;
};

export type LoadingEntityResponse = {
  __typename?: 'LoadingEntityResponse';
  data: Maybe<LoadingEntity>;
};

export type LoadingInput = {
  background: InputMaybe<ComponentPostProcessingVideoInput>;
  checkAfterSpinner: InputMaybe<ComponentGeneralImageInput>;
  connectionAnimation: InputMaybe<ComponentGeneralImageInput>;
  loadingTexts: InputMaybe<Array<InputMaybe<ComponentGeneralListInput>>>;
};

export type LoadingRelationResponseCollection = {
  __typename?: 'LoadingRelationResponseCollection';
  data: Array<LoadingEntity>;
};

export type Mask = {
  __typename?: 'Mask';
  arrow: Maybe<ComponentGeneralImage>;
  body: Maybe<ComponentGeneralImage>;
  buttonOne: ComponentGeneralButton;
  buttonTwo: ComponentGeneralButton;
  cameraHint: Maybe<Scalars['String']>;
  countdown: Scalars['Int'];
  createdAt: Maybe<Scalars['DateTime']>;
  head: ComponentGeneralImage;
  hintBulletPoints: Array<Maybe<ComponentGeneralBulletPoint>>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<MaskRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type MaskHintBulletPointsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MaskEntity = {
  __typename?: 'MaskEntity';
  attributes: Maybe<Mask>;
  id: Maybe<Scalars['ID']>;
};

export type MaskEntityResponse = {
  __typename?: 'MaskEntityResponse';
  data: Maybe<MaskEntity>;
};

export type MaskInput = {
  arrow: InputMaybe<ComponentGeneralImageInput>;
  body: InputMaybe<ComponentGeneralImageInput>;
  buttonOne: InputMaybe<ComponentGeneralButtonInput>;
  buttonTwo: InputMaybe<ComponentGeneralButtonInput>;
  cameraHint: InputMaybe<Scalars['String']>;
  countdown: InputMaybe<Scalars['Int']>;
  head: InputMaybe<ComponentGeneralImageInput>;
  hintBulletPoints: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
};

export type MaskRelationResponseCollection = {
  __typename?: 'MaskRelationResponseCollection';
  data: Array<MaskEntity>;
};

export type Meta = {
  __typename?: 'Meta';
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<MetaRelationResponseCollection>;
  metaDescription: Scalars['String'];
  ogDescription: Maybe<Scalars['String']>;
  ogImage: Maybe<UploadFileEntityResponse>;
  ogTitle: Maybe<Scalars['String']>;
  pageTitle: Scalars['String'];
  themeColor: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type MetaEntity = {
  __typename?: 'MetaEntity';
  attributes: Maybe<Meta>;
  id: Maybe<Scalars['ID']>;
};

export type MetaEntityResponse = {
  __typename?: 'MetaEntityResponse';
  data: Maybe<MetaEntity>;
};

export type MetaInput = {
  metaDescription: InputMaybe<Scalars['String']>;
  ogDescription: InputMaybe<Scalars['String']>;
  ogImage: InputMaybe<Scalars['ID']>;
  ogTitle: InputMaybe<Scalars['String']>;
  pageTitle: InputMaybe<Scalars['String']>;
  themeColor: InputMaybe<Scalars['String']>;
};

export type MetaRelationResponseCollection = {
  __typename?: 'MetaRelationResponseCollection';
  data: Array<MetaEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword: Maybe<UsersPermissionsLoginPayload>;
  createAgeLocalization: Maybe<AgeEntityResponse>;
  createCancelCallLocalization: Maybe<CancelCallEntityResponse>;
  createChatBranch: Maybe<ChatBranchEntityResponse>;
  createChatBranchAi: Maybe<ChatBranchAiEntityResponse>;
  createChatBranchOver50: Maybe<ChatBranchOver50EntityResponse>;
  createChatEvent: Maybe<ChatEventEntityResponse>;
  createChatSteleLocalization: Maybe<ChatSteleEntityResponse>;
  createChatbotLocalization: Maybe<ChatbotEntityResponse>;
  createComingSoonLocalization: Maybe<ComingSoonEntityResponse>;
  createEndOfCallOldLocalization: Maybe<EndOfCallOldEntityResponse>;
  createEndOfCallRegularLocalization: Maybe<EndOfCallRegularEntityResponse>;
  createGlobalEventLocalization: Maybe<GlobalEventEntityResponse>;
  createGlobalLocalization: Maybe<GlobalEntityResponse>;
  createHintLocalization: Maybe<HintEntityResponse>;
  createI18N: Maybe<I18NEntityResponse>;
  createI18NLocalization: Maybe<I18NEntityResponse>;
  createImprintLocalization: Maybe<ImprintEntityResponse>;
  createLandingLocalization: Maybe<LandingEntityResponse>;
  createLoadingLocalization: Maybe<LoadingEntityResponse>;
  createMaskLocalization: Maybe<MaskEntityResponse>;
  createMetaLocalization: Maybe<MetaEntityResponse>;
  createPageNotFoundLocalization: Maybe<PageNotFoundEntityResponse>;
  createPostProcessing: Maybe<PostProcessingEntityResponse>;
  createPrivacyPolicyLocalization: Maybe<PrivacyPolicyEntityResponse>;
  createStartLocalization: Maybe<StartEntityResponse>;
  createTutorialLocalization: Maybe<TutorialEntityResponse>;
  createUploadFile: Maybe<UploadFileEntityResponse>;
  createUploadFolder: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAge: Maybe<AgeEntityResponse>;
  deleteCancelCall: Maybe<CancelCallEntityResponse>;
  deleteChatBranch: Maybe<ChatBranchEntityResponse>;
  deleteChatBranchAi: Maybe<ChatBranchAiEntityResponse>;
  deleteChatBranchOver50: Maybe<ChatBranchOver50EntityResponse>;
  deleteChatEvent: Maybe<ChatEventEntityResponse>;
  deleteChatStele: Maybe<ChatSteleEntityResponse>;
  deleteChatbot: Maybe<ChatbotEntityResponse>;
  deleteComingSoon: Maybe<ComingSoonEntityResponse>;
  deleteEndOfCallOld: Maybe<EndOfCallOldEntityResponse>;
  deleteEndOfCallRegular: Maybe<EndOfCallRegularEntityResponse>;
  deleteGlobal: Maybe<GlobalEntityResponse>;
  deleteGlobalEvent: Maybe<GlobalEventEntityResponse>;
  deleteHint: Maybe<HintEntityResponse>;
  deleteI18N: Maybe<I18NEntityResponse>;
  deleteImprint: Maybe<ImprintEntityResponse>;
  deleteLanding: Maybe<LandingEntityResponse>;
  deleteLoading: Maybe<LoadingEntityResponse>;
  deleteMask: Maybe<MaskEntityResponse>;
  deleteMeta: Maybe<MetaEntityResponse>;
  deletePageNotFound: Maybe<PageNotFoundEntityResponse>;
  deletePostProcessing: Maybe<PostProcessingEntityResponse>;
  deletePrivacyPolicy: Maybe<PrivacyPolicyEntityResponse>;
  deleteStart: Maybe<StartEntityResponse>;
  deleteTutorial: Maybe<TutorialEntityResponse>;
  deleteUploadFile: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword: Maybe<UsersPermissionsLoginPayload>;
  updateAge: Maybe<AgeEntityResponse>;
  updateCancelCall: Maybe<CancelCallEntityResponse>;
  updateChatBranch: Maybe<ChatBranchEntityResponse>;
  updateChatBranchAi: Maybe<ChatBranchAiEntityResponse>;
  updateChatBranchOver50: Maybe<ChatBranchOver50EntityResponse>;
  updateChatEvent: Maybe<ChatEventEntityResponse>;
  updateChatStele: Maybe<ChatSteleEntityResponse>;
  updateChatbot: Maybe<ChatbotEntityResponse>;
  updateComingSoon: Maybe<ComingSoonEntityResponse>;
  updateEndOfCallOld: Maybe<EndOfCallOldEntityResponse>;
  updateEndOfCallRegular: Maybe<EndOfCallRegularEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateGlobal: Maybe<GlobalEntityResponse>;
  updateGlobalEvent: Maybe<GlobalEventEntityResponse>;
  updateHint: Maybe<HintEntityResponse>;
  updateI18N: Maybe<I18NEntityResponse>;
  updateImprint: Maybe<ImprintEntityResponse>;
  updateLanding: Maybe<LandingEntityResponse>;
  updateLoading: Maybe<LoadingEntityResponse>;
  updateMask: Maybe<MaskEntityResponse>;
  updateMeta: Maybe<MetaEntityResponse>;
  updatePageNotFound: Maybe<PageNotFoundEntityResponse>;
  updatePostProcessing: Maybe<PostProcessingEntityResponse>;
  updatePrivacyPolicy: Maybe<PrivacyPolicyEntityResponse>;
  updateStart: Maybe<StartEntityResponse>;
  updateTutorial: Maybe<TutorialEntityResponse>;
  updateUploadFile: Maybe<UploadFileEntityResponse>;
  updateUploadFolder: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateAgeLocalizationArgs = {
  data: InputMaybe<AgeInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCancelCallLocalizationArgs = {
  data: InputMaybe<CancelCallInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateChatBranchArgs = {
  data: ChatBranchInput;
};


export type MutationCreateChatBranchAiArgs = {
  data: ChatBranchAiInput;
};


export type MutationCreateChatBranchOver50Args = {
  data: ChatBranchOver50Input;
};


export type MutationCreateChatEventArgs = {
  data: ChatEventInput;
};


export type MutationCreateChatSteleLocalizationArgs = {
  data: InputMaybe<ChatSteleInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateChatbotLocalizationArgs = {
  data: InputMaybe<ChatbotInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateComingSoonLocalizationArgs = {
  data: InputMaybe<ComingSoonInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateEndOfCallOldLocalizationArgs = {
  data: InputMaybe<EndOfCallOldInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateEndOfCallRegularLocalizationArgs = {
  data: InputMaybe<EndOfCallRegularInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateGlobalEventLocalizationArgs = {
  data: InputMaybe<GlobalEventInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateGlobalLocalizationArgs = {
  data: InputMaybe<GlobalInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateHintLocalizationArgs = {
  data: InputMaybe<HintInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateI18NArgs = {
  data: I18NInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateI18NLocalizationArgs = {
  data: InputMaybe<I18NInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateImprintLocalizationArgs = {
  data: InputMaybe<ImprintInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateLandingLocalizationArgs = {
  data: InputMaybe<LandingInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateLoadingLocalizationArgs = {
  data: InputMaybe<LoadingInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateMaskLocalizationArgs = {
  data: InputMaybe<MaskInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateMetaLocalizationArgs = {
  data: InputMaybe<MetaInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageNotFoundLocalizationArgs = {
  data: InputMaybe<PageNotFoundInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePostProcessingArgs = {
  data: PostProcessingInput;
};


export type MutationCreatePrivacyPolicyLocalizationArgs = {
  data: InputMaybe<PrivacyPolicyInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateStartLocalizationArgs = {
  data: InputMaybe<StartInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTutorialLocalizationArgs = {
  data: InputMaybe<TutorialInput>;
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteAgeArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteCancelCallArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteChatBranchArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChatBranchAiArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChatBranchOver50Args = {
  id: Scalars['ID'];
};


export type MutationDeleteChatEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChatSteleArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteChatbotArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteComingSoonArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteEndOfCallOldArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteEndOfCallRegularArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteGlobalArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteGlobalEventArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteHintArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteI18NArgs = {
  id: Scalars['ID'];
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteImprintArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteLandingArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteLoadingArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteMaskArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteMetaArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePageNotFoundArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePostProcessingArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePrivacyPolicyArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteStartArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTutorialArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref: InputMaybe<Scalars['String']>;
  refId: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateAgeArgs = {
  data: AgeInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateCancelCallArgs = {
  data: CancelCallInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateChatBranchArgs = {
  data: ChatBranchInput;
  id: Scalars['ID'];
};


export type MutationUpdateChatBranchAiArgs = {
  data: ChatBranchAiInput;
  id: Scalars['ID'];
};


export type MutationUpdateChatBranchOver50Args = {
  data: ChatBranchOver50Input;
  id: Scalars['ID'];
};


export type MutationUpdateChatEventArgs = {
  data: ChatEventInput;
  id: Scalars['ID'];
};


export type MutationUpdateChatSteleArgs = {
  data: ChatSteleInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateChatbotArgs = {
  data: ChatbotInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateComingSoonArgs = {
  data: ComingSoonInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateEndOfCallOldArgs = {
  data: EndOfCallOldInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateEndOfCallRegularArgs = {
  data: EndOfCallRegularInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: InputMaybe<FileInfoInput>;
};


export type MutationUpdateGlobalArgs = {
  data: GlobalInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateGlobalEventArgs = {
  data: GlobalEventInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateHintArgs = {
  data: HintInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateI18NArgs = {
  data: I18NInput;
  id: Scalars['ID'];
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateImprintArgs = {
  data: ImprintInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateLandingArgs = {
  data: LandingInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateLoadingArgs = {
  data: LoadingInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateMaskArgs = {
  data: MaskInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateMetaArgs = {
  data: MetaInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePageNotFoundArgs = {
  data: PageNotFoundInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePostProcessingArgs = {
  data: PostProcessingInput;
  id: Scalars['ID'];
};


export type MutationUpdatePrivacyPolicyArgs = {
  data: PrivacyPolicyInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateStartArgs = {
  data: StartInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTutorialArgs = {
  data: TutorialInput;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  field: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info: InputMaybe<FileInfoInput>;
  ref: InputMaybe<Scalars['String']>;
  refId: InputMaybe<Scalars['ID']>;
};

export type PageNotFound = {
  __typename?: 'PageNotFound';
  button: ComponentGeneralButton;
  createdAt: Maybe<Scalars['DateTime']>;
  gradientLeft: ComponentGeneralImage;
  heroDesktop: ComponentGeneralImage;
  heroMobile: ComponentGeneralImage;
  heroOverlay: ComponentGeneralImage;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<PageNotFoundRelationResponseCollection>;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type PageNotFoundEntity = {
  __typename?: 'PageNotFoundEntity';
  attributes: Maybe<PageNotFound>;
  id: Maybe<Scalars['ID']>;
};

export type PageNotFoundEntityResponse = {
  __typename?: 'PageNotFoundEntityResponse';
  data: Maybe<PageNotFoundEntity>;
};

export type PageNotFoundInput = {
  button: InputMaybe<ComponentGeneralButtonInput>;
  gradientLeft: InputMaybe<ComponentGeneralImageInput>;
  heroDesktop: InputMaybe<ComponentGeneralImageInput>;
  heroMobile: InputMaybe<ComponentGeneralImageInput>;
  heroOverlay: InputMaybe<ComponentGeneralImageInput>;
  subtitle: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
};

export type PageNotFoundRelationResponseCollection = {
  __typename?: 'PageNotFoundRelationResponseCollection';
  data: Array<PageNotFoundEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  pageSize: InputMaybe<Scalars['Int']>;
  start: InputMaybe<Scalars['Int']>;
};

export type PostProcessing = {
  __typename?: 'PostProcessing';
  Behind: Array<Maybe<PostProcessingBehindDynamicZone>>;
  Infront: Array<Maybe<PostProcessingInfrontDynamicZone>>;
  createdAt: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type PostProcessingBehindDynamicZone = ComponentPostProcessingImage | ComponentPostProcessingVideo | Error;

export type PostProcessingEntity = {
  __typename?: 'PostProcessingEntity';
  attributes: Maybe<PostProcessing>;
  id: Maybe<Scalars['ID']>;
};

export type PostProcessingEntityResponse = {
  __typename?: 'PostProcessingEntityResponse';
  data: Maybe<PostProcessingEntity>;
};

export type PostProcessingEntityResponseCollection = {
  __typename?: 'PostProcessingEntityResponseCollection';
  data: Array<PostProcessingEntity>;
  meta: ResponseCollectionMeta;
};

export type PostProcessingFiltersInput = {
  and: InputMaybe<Array<InputMaybe<PostProcessingFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<PostProcessingFiltersInput>;
  or: InputMaybe<Array<InputMaybe<PostProcessingFiltersInput>>>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type PostProcessingInfrontDynamicZone = ComponentPostProcessingImage | ComponentPostProcessingVideo | Error;

export type PostProcessingInput = {
  Behind: InputMaybe<Array<Scalars['PostProcessingBehindDynamicZoneInput']>>;
  Infront: InputMaybe<Array<Scalars['PostProcessingInfrontDynamicZoneInput']>>;
  name: InputMaybe<Scalars['String']>;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  background: ComponentGeneralImage;
  button: ComponentGeneralButton;
  cardBulletPoints: Array<Maybe<ComponentGeneralBulletPoint>>;
  cardContent: Maybe<Scalars['String']>;
  cardSubtitle: Scalars['String'];
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<PrivacyPolicyRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type PrivacyPolicyCardBulletPointsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PrivacyPolicyEntity = {
  __typename?: 'PrivacyPolicyEntity';
  attributes: Maybe<PrivacyPolicy>;
  id: Maybe<Scalars['ID']>;
};

export type PrivacyPolicyEntityResponse = {
  __typename?: 'PrivacyPolicyEntityResponse';
  data: Maybe<PrivacyPolicyEntity>;
};

export type PrivacyPolicyInput = {
  background: InputMaybe<ComponentGeneralImageInput>;
  button: InputMaybe<ComponentGeneralButtonInput>;
  cardBulletPoints: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  cardContent: InputMaybe<Scalars['String']>;
  cardSubtitle: InputMaybe<Scalars['String']>;
  cardTitle: InputMaybe<Scalars['String']>;
};

export type PrivacyPolicyRelationResponseCollection = {
  __typename?: 'PrivacyPolicyRelationResponseCollection';
  data: Array<PrivacyPolicyEntity>;
};

export type Query = {
  __typename?: 'Query';
  age: Maybe<AgeEntityResponse>;
  cancelCall: Maybe<CancelCallEntityResponse>;
  chatBranch: Maybe<ChatBranchEntityResponse>;
  chatBranchAi: Maybe<ChatBranchAiEntityResponse>;
  chatBranchAis: Maybe<ChatBranchAiEntityResponseCollection>;
  chatBranchOver50: Maybe<ChatBranchOver50EntityResponse>;
  chatBranchOver50S: Maybe<ChatBranchOver50EntityResponseCollection>;
  chatBranches: Maybe<ChatBranchEntityResponseCollection>;
  chatEvent: Maybe<ChatEventEntityResponse>;
  chatEvents: Maybe<ChatEventEntityResponseCollection>;
  chatStele: Maybe<ChatSteleEntityResponse>;
  chatbot: Maybe<ChatbotEntityResponse>;
  comingSoon: Maybe<ComingSoonEntityResponse>;
  endOfCallOld: Maybe<EndOfCallOldEntityResponse>;
  endOfCallRegular: Maybe<EndOfCallRegularEntityResponse>;
  global: Maybe<GlobalEntityResponse>;
  globalEvent: Maybe<GlobalEventEntityResponse>;
  hint: Maybe<HintEntityResponse>;
  i18N: Maybe<I18NEntityResponse>;
  i18NLocale: Maybe<I18NLocaleEntityResponse>;
  i18NLocales: Maybe<I18NLocaleEntityResponseCollection>;
  i18Ns: Maybe<I18NEntityResponseCollection>;
  imprint: Maybe<ImprintEntityResponse>;
  landing: Maybe<LandingEntityResponse>;
  loading: Maybe<LoadingEntityResponse>;
  mask: Maybe<MaskEntityResponse>;
  me: Maybe<UsersPermissionsMe>;
  meta: Maybe<MetaEntityResponse>;
  pageNotFound: Maybe<PageNotFoundEntityResponse>;
  postProcessing: Maybe<PostProcessingEntityResponse>;
  postProcessings: Maybe<PostProcessingEntityResponseCollection>;
  privacyPolicy: Maybe<PrivacyPolicyEntityResponse>;
  start: Maybe<StartEntityResponse>;
  tutorial: Maybe<TutorialEntityResponse>;
  uploadFile: Maybe<UploadFileEntityResponse>;
  uploadFiles: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder: Maybe<UploadFolderEntityResponse>;
  uploadFolders: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryAgeArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryCancelCallArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryChatBranchArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryChatBranchAiArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryChatBranchAisArgs = {
  filters: InputMaybe<ChatBranchAiFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryChatBranchOver50Args = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryChatBranchOver50SArgs = {
  filters: InputMaybe<ChatBranchOver50FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryChatBranchesArgs = {
  filters: InputMaybe<ChatBranchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryChatEventArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryChatEventsArgs = {
  filters: InputMaybe<ChatEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryChatSteleArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryChatbotArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryComingSoonArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryEndOfCallOldArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryEndOfCallRegularArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryGlobalArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryGlobalEventArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryHintArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryI18NArgs = {
  id: InputMaybe<Scalars['ID']>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryI18NLocaleArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryI18NsArgs = {
  filters: InputMaybe<I18NFiltersInput>;
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryImprintArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryLandingArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryLoadingArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryMaskArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryMetaArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPageNotFoundArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPostProcessingArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryPostProcessingsArgs = {
  filters: InputMaybe<PostProcessingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPrivacyPolicyArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryStartArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryTutorialArgs = {
  locale: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryUploadFileArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type Start = {
  __typename?: 'Start';
  cardFourAccordions: Array<Maybe<ComponentGeneralAccordion>>;
  cardFourButton: ComponentGeneralButtonLink;
  cardFourButtonLink: ComponentGeneralButtonLink;
  cardFourContent: Scalars['String'];
  cardFourSubtitle: Scalars['String'];
  cardFourTitle: ComponentGeneralBulletPoint;
  cardOneButton: ComponentGeneralButton;
  cardOneRadioButtonOne: Scalars['String'];
  cardOneRadioButtonThree: Scalars['String'];
  cardOneRadioButtonTwo: Scalars['String'];
  cardOneTitle: Scalars['String'];
  cardThreeContent: Scalars['String'];
  cardThreeDisclaimer: Scalars['String'];
  cardThreeImages: Array<Maybe<ComponentGeneralImage>>;
  cardThreeSubtitle: Scalars['String'];
  cardThreeTitle: Scalars['String'];
  cardTwoBenefits: Array<Maybe<ComponentGeneralCardBenefit>>;
  cardTwoContent: Scalars['String'];
  cardTwoTitle: ComponentGeneralBulletPoint;
  claim: ComponentGeneralImage;
  createdAt: Maybe<Scalars['DateTime']>;
  dropdowns: Array<Maybe<ComponentGeneralDropdown>>;
  dropdownsTitle: ComponentGeneralBulletPoint;
  footerAccessibility: ComponentGeneralLinkList;
  footerClaim: Scalars['String'];
  footerContact: ComponentGeneralLinkList;
  footerImprint: ComponentGeneralLinkList;
  footerLogo: ComponentGeneralImage;
  footerLogoLink: Scalars['String'];
  footerPrivacyPolicy: ComponentGeneralLinkList;
  hero320px: ComponentGeneralImage;
  hero480px: ComponentGeneralImage;
  hero768px: ComponentGeneralImage;
  hero1024px: ComponentGeneralImage;
  hero1280px: ComponentGeneralImage;
  hero1920px: ComponentGeneralImage;
  heroButton: ComponentGeneralButton;
  heroContent: Scalars['String'];
  heroLink: Scalars['String'];
  heroTitle: Scalars['String'];
  heroTitleBold: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<StartRelationResponseCollection>;
  logo: ComponentGeneralImage;
  modalButtonConsulting: ComponentGeneralButton;
  modalButtonSendMail: ComponentGeneralButton;
  modalButtonVideoCall: ComponentGeneralButtonLink;
  modalCheckboxesTitle: Scalars['String'];
  modalCloseIcon: ComponentGeneralImage;
  modalDatasecurityCheckbox: Scalars['String'];
  modalFirstInputPlaceholder: Scalars['String'];
  modalFirstRadioButton: Scalars['String'];
  modalLocationInputIcon: ComponentGeneralImage;
  modalLocationInputPlaceholder: Scalars['String'];
  modalLocationInputTitle: Scalars['String'];
  modalMailInputPlaceholder: Scalars['String'];
  modalPhoneInputPlaceholder: Scalars['String'];
  modalRequiredClaim: Scalars['String'];
  modalSecondInputPlaceholder: Scalars['String'];
  modalSecondRadioButton: Scalars['String'];
  modalSparkasseNotFoundError: Scalars['String'];
  modalSuccessfullySubmitted: Scalars['String'];
  modalThirdRadioButton: Scalars['String'];
  modalTitle: Scalars['String'];
  noCardOneAsterisk: Scalars['String'];
  noCardOneContent: Scalars['String'];
  noCardOneTitle: ComponentGeneralBulletPoint;
  noCardThreeButton: ComponentGeneralButton;
  noCardThreeImages: Array<Maybe<ComponentGeneralImage>>;
  noCardThreeTitle: ComponentGeneralBulletPoint;
  noCardTwoButton: ComponentGeneralButtonLink;
  noCardTwoContent: Scalars['String'];
  noCardTwoHotlineHint: Scalars['String'];
  noCardTwoHotlineNumber: Scalars['String'];
  noCardTwoTitle: Scalars['String'];
  participatingSparkassen: Array<Maybe<ComponentGeneralLinkList>>;
  participatingSparkassenListIcon: ComponentGeneralImage;
  shareFeatureIcon: ComponentGeneralImage;
  shareFeatureText: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type StartCardFourAccordionsArgs = {
  filters: InputMaybe<ComponentGeneralAccordionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StartCardThreeImagesArgs = {
  filters: InputMaybe<ComponentGeneralImageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StartCardTwoBenefitsArgs = {
  filters: InputMaybe<ComponentGeneralCardBenefitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StartDropdownsArgs = {
  filters: InputMaybe<ComponentGeneralDropdownFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StartNoCardThreeImagesArgs = {
  filters: InputMaybe<ComponentGeneralImageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StartParticipatingSparkassenArgs = {
  filters: InputMaybe<ComponentGeneralLinkListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StartEntity = {
  __typename?: 'StartEntity';
  attributes: Maybe<Start>;
  id: Maybe<Scalars['ID']>;
};

export type StartEntityResponse = {
  __typename?: 'StartEntityResponse';
  data: Maybe<StartEntity>;
};

export type StartInput = {
  cardFourAccordions: InputMaybe<Array<InputMaybe<ComponentGeneralAccordionInput>>>;
  cardFourButton: InputMaybe<ComponentGeneralButtonLinkInput>;
  cardFourButtonLink: InputMaybe<ComponentGeneralButtonLinkInput>;
  cardFourContent: InputMaybe<Scalars['String']>;
  cardFourSubtitle: InputMaybe<Scalars['String']>;
  cardFourTitle: InputMaybe<ComponentGeneralBulletPointInput>;
  cardOneButton: InputMaybe<ComponentGeneralButtonInput>;
  cardOneRadioButtonOne: InputMaybe<Scalars['String']>;
  cardOneRadioButtonThree: InputMaybe<Scalars['String']>;
  cardOneRadioButtonTwo: InputMaybe<Scalars['String']>;
  cardOneTitle: InputMaybe<Scalars['String']>;
  cardThreeContent: InputMaybe<Scalars['String']>;
  cardThreeDisclaimer: InputMaybe<Scalars['String']>;
  cardThreeImages: InputMaybe<Array<InputMaybe<ComponentGeneralImageInput>>>;
  cardThreeSubtitle: InputMaybe<Scalars['String']>;
  cardThreeTitle: InputMaybe<Scalars['String']>;
  cardTwoBenefits: InputMaybe<Array<InputMaybe<ComponentGeneralCardBenefitInput>>>;
  cardTwoContent: InputMaybe<Scalars['String']>;
  cardTwoTitle: InputMaybe<ComponentGeneralBulletPointInput>;
  claim: InputMaybe<ComponentGeneralImageInput>;
  dropdowns: InputMaybe<Array<InputMaybe<ComponentGeneralDropdownInput>>>;
  dropdownsTitle: InputMaybe<ComponentGeneralBulletPointInput>;
  footerAccessibility: InputMaybe<ComponentGeneralLinkListInput>;
  footerClaim: InputMaybe<Scalars['String']>;
  footerContact: InputMaybe<ComponentGeneralLinkListInput>;
  footerImprint: InputMaybe<ComponentGeneralLinkListInput>;
  footerLogo: InputMaybe<ComponentGeneralImageInput>;
  footerLogoLink: InputMaybe<Scalars['String']>;
  footerPrivacyPolicy: InputMaybe<ComponentGeneralLinkListInput>;
  hero320px: InputMaybe<ComponentGeneralImageInput>;
  hero480px: InputMaybe<ComponentGeneralImageInput>;
  hero768px: InputMaybe<ComponentGeneralImageInput>;
  hero1024px: InputMaybe<ComponentGeneralImageInput>;
  hero1280px: InputMaybe<ComponentGeneralImageInput>;
  hero1920px: InputMaybe<ComponentGeneralImageInput>;
  heroButton: InputMaybe<ComponentGeneralButtonInput>;
  heroContent: InputMaybe<Scalars['String']>;
  heroLink: InputMaybe<Scalars['String']>;
  heroTitle: InputMaybe<Scalars['String']>;
  heroTitleBold: InputMaybe<Scalars['String']>;
  logo: InputMaybe<ComponentGeneralImageInput>;
  modalButtonConsulting: InputMaybe<ComponentGeneralButtonInput>;
  modalButtonSendMail: InputMaybe<ComponentGeneralButtonInput>;
  modalButtonVideoCall: InputMaybe<ComponentGeneralButtonLinkInput>;
  modalCheckboxesTitle: InputMaybe<Scalars['String']>;
  modalCloseIcon: InputMaybe<ComponentGeneralImageInput>;
  modalDatasecurityCheckbox: InputMaybe<Scalars['String']>;
  modalFirstInputPlaceholder: InputMaybe<Scalars['String']>;
  modalFirstRadioButton: InputMaybe<Scalars['String']>;
  modalLocationInputIcon: InputMaybe<ComponentGeneralImageInput>;
  modalLocationInputPlaceholder: InputMaybe<Scalars['String']>;
  modalLocationInputTitle: InputMaybe<Scalars['String']>;
  modalMailInputPlaceholder: InputMaybe<Scalars['String']>;
  modalPhoneInputPlaceholder: InputMaybe<Scalars['String']>;
  modalRequiredClaim: InputMaybe<Scalars['String']>;
  modalSecondInputPlaceholder: InputMaybe<Scalars['String']>;
  modalSecondRadioButton: InputMaybe<Scalars['String']>;
  modalSparkasseNotFoundError: InputMaybe<Scalars['String']>;
  modalSuccessfullySubmitted: InputMaybe<Scalars['String']>;
  modalThirdRadioButton: InputMaybe<Scalars['String']>;
  modalTitle: InputMaybe<Scalars['String']>;
  noCardOneAsterisk: InputMaybe<Scalars['String']>;
  noCardOneContent: InputMaybe<Scalars['String']>;
  noCardOneTitle: InputMaybe<ComponentGeneralBulletPointInput>;
  noCardThreeButton: InputMaybe<ComponentGeneralButtonInput>;
  noCardThreeImages: InputMaybe<Array<InputMaybe<ComponentGeneralImageInput>>>;
  noCardThreeTitle: InputMaybe<ComponentGeneralBulletPointInput>;
  noCardTwoButton: InputMaybe<ComponentGeneralButtonLinkInput>;
  noCardTwoContent: InputMaybe<Scalars['String']>;
  noCardTwoHotlineHint: InputMaybe<Scalars['String']>;
  noCardTwoHotlineNumber: InputMaybe<Scalars['String']>;
  noCardTwoTitle: InputMaybe<Scalars['String']>;
  participatingSparkassen: InputMaybe<Array<InputMaybe<ComponentGeneralLinkListInput>>>;
  participatingSparkassenListIcon: InputMaybe<ComponentGeneralImageInput>;
  shareFeatureIcon: InputMaybe<ComponentGeneralImageInput>;
  shareFeatureText: InputMaybe<Scalars['String']>;
};

export type StartRelationResponseCollection = {
  __typename?: 'StartRelationResponseCollection';
  data: Array<StartEntity>;
};

export type StringFilterInput = {
  and: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains: InputMaybe<Scalars['String']>;
  containsi: InputMaybe<Scalars['String']>;
  endsWith: InputMaybe<Scalars['String']>;
  eq: InputMaybe<Scalars['String']>;
  eqi: InputMaybe<Scalars['String']>;
  gt: InputMaybe<Scalars['String']>;
  gte: InputMaybe<Scalars['String']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt: InputMaybe<Scalars['String']>;
  lte: InputMaybe<Scalars['String']>;
  ne: InputMaybe<Scalars['String']>;
  not: InputMaybe<StringFilterInput>;
  notContains: InputMaybe<Scalars['String']>;
  notContainsi: InputMaybe<Scalars['String']>;
  notIn: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull: InputMaybe<Scalars['Boolean']>;
  null: InputMaybe<Scalars['Boolean']>;
  or: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith: InputMaybe<Scalars['String']>;
};

export type Tutorial = {
  __typename?: 'Tutorial';
  background: ComponentGeneralImage;
  bulletPoints: Array<Maybe<ComponentGeneralBulletPoint>>;
  buttonOne: ComponentGeneralButton;
  buttonTwo: ComponentGeneralButton;
  cardTitle: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  hintDescription: Scalars['String'];
  hintTitle: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  localizations: Maybe<TutorialRelationResponseCollection>;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type TutorialBulletPointsArgs = {
  filters: InputMaybe<ComponentGeneralBulletPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TutorialEntity = {
  __typename?: 'TutorialEntity';
  attributes: Maybe<Tutorial>;
  id: Maybe<Scalars['ID']>;
};

export type TutorialEntityResponse = {
  __typename?: 'TutorialEntityResponse';
  data: Maybe<TutorialEntity>;
};

export type TutorialInput = {
  background: InputMaybe<ComponentGeneralImageInput>;
  bulletPoints: InputMaybe<Array<InputMaybe<ComponentGeneralBulletPointInput>>>;
  buttonOne: InputMaybe<ComponentGeneralButtonInput>;
  buttonTwo: InputMaybe<ComponentGeneralButtonInput>;
  cardTitle: InputMaybe<Scalars['String']>;
  hintDescription: InputMaybe<Scalars['String']>;
  hintTitle: InputMaybe<Scalars['String']>;
};

export type TutorialRelationResponseCollection = {
  __typename?: 'TutorialRelationResponseCollection';
  data: Array<TutorialEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText: Maybe<Scalars['String']>;
  caption: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  ext: Maybe<Scalars['String']>;
  formats: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata: Maybe<Scalars['JSON']>;
  related: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes: Maybe<UploadFile>;
  id: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText: InputMaybe<StringFilterInput>;
  and: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption: InputMaybe<StringFilterInput>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  ext: InputMaybe<StringFilterInput>;
  folder: InputMaybe<UploadFolderFiltersInput>;
  folderPath: InputMaybe<StringFilterInput>;
  formats: InputMaybe<JsonFilterInput>;
  hash: InputMaybe<StringFilterInput>;
  height: InputMaybe<IntFilterInput>;
  id: InputMaybe<IdFilterInput>;
  mime: InputMaybe<StringFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<UploadFileFiltersInput>;
  or: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl: InputMaybe<StringFilterInput>;
  provider: InputMaybe<StringFilterInput>;
  provider_metadata: InputMaybe<JsonFilterInput>;
  size: InputMaybe<FloatFilterInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
  url: InputMaybe<StringFilterInput>;
  width: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText: InputMaybe<Scalars['String']>;
  caption: InputMaybe<Scalars['String']>;
  ext: InputMaybe<Scalars['String']>;
  folder: InputMaybe<Scalars['ID']>;
  folderPath: InputMaybe<Scalars['String']>;
  formats: InputMaybe<Scalars['JSON']>;
  hash: InputMaybe<Scalars['String']>;
  height: InputMaybe<Scalars['Int']>;
  mime: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  previewUrl: InputMaybe<Scalars['String']>;
  provider: InputMaybe<Scalars['String']>;
  provider_metadata: InputMaybe<Scalars['JSON']>;
  size: InputMaybe<Scalars['Float']>;
  url: InputMaybe<Scalars['String']>;
  width: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children: Maybe<UploadFolderRelationResponseCollection>;
  createdAt: Maybe<Scalars['DateTime']>;
  files: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes: Maybe<UploadFolder>;
  id: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children: InputMaybe<UploadFolderFiltersInput>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  files: InputMaybe<UploadFileFiltersInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<UploadFolderFiltersInput>;
  or: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent: InputMaybe<UploadFolderFiltersInput>;
  path: InputMaybe<StringFilterInput>;
  pathId: InputMaybe<IntFilterInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: InputMaybe<Scalars['String']>;
  parent: InputMaybe<Scalars['ID']>;
  path: InputMaybe<Scalars['String']>;
  pathId: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked: Maybe<Scalars['Boolean']>;
  confirmed: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt: Maybe<Scalars['DateTime']>;
  role: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes: Maybe<UsersPermissionsPermission>;
  id: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action: InputMaybe<StringFilterInput>;
  and: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  id: InputMaybe<IdFilterInput>;
  not: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  users: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes: Maybe<UsersPermissionsRole>;
  id: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  description: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  name: InputMaybe<StringFilterInput>;
  not: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type: InputMaybe<StringFilterInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
  users: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type: InputMaybe<Scalars['String']>;
  users: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked: Maybe<Scalars['Boolean']>;
  confirmed: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  provider: Maybe<Scalars['String']>;
  role: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes: Maybe<UsersPermissionsUser>;
  id: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked: InputMaybe<BooleanFilterInput>;
  confirmationToken: InputMaybe<StringFilterInput>;
  confirmed: InputMaybe<BooleanFilterInput>;
  createdAt: InputMaybe<DateTimeFilterInput>;
  email: InputMaybe<StringFilterInput>;
  id: InputMaybe<IdFilterInput>;
  not: InputMaybe<UsersPermissionsUserFiltersInput>;
  or: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password: InputMaybe<StringFilterInput>;
  provider: InputMaybe<StringFilterInput>;
  resetPasswordToken: InputMaybe<StringFilterInput>;
  role: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt: InputMaybe<DateTimeFilterInput>;
  username: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked: InputMaybe<Scalars['Boolean']>;
  confirmationToken: InputMaybe<Scalars['String']>;
  confirmed: InputMaybe<Scalars['Boolean']>;
  email: InputMaybe<Scalars['String']>;
  password: InputMaybe<Scalars['String']>;
  provider: InputMaybe<Scalars['String']>;
  resetPasswordToken: InputMaybe<Scalars['String']>;
  role: InputMaybe<Scalars['ID']>;
  username: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};
